import { Employee } from 'models';

interface EmployeeNameProps {
    employee: Employee;
}
export const EmployeeName = ({ employee }: EmployeeNameProps) => (
    <span>{employee.lastName + ', ' + employee.firstName}</span>
);
